import React from 'react';

const ConfirmationModal = ({ isVisible, title, description, onConfirm, onCancel, deleting }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-3xl shadow-lg w-96">
        <h2 className="text-xl font-bold mb-4 text-center">{title}</h2>
        <p className="text-gray-700 mb-6 break-words whitespace-normal">{description}</p>
        <div className="flex justify-end gap-4">
          <button className="py-2 px-4 bg-gray-300 rounded-full hover:bg-gray-400" onClick={onCancel}>
            Cancel
          </button>
          <button className="py-2 px-4 bg-red-600 text-white rounded-full hover:bg-red-700" onClick={onConfirm}>
            {deleting ? "Deleting..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
